module.exports = __webpack_public_path__ + "static/media/dig.8349030e.png";